<script>
    import {onMount} from "svelte";

    export let urls = [];
    export let start = [];
    export let noMobile = true;
    let video;
    let i = 0;

    onMount(() => {
        video.play();
    });

    function onEnd() {
        if(urls.length === 1){
            if(start[i]) {
                video.play();
                video.currentTime = start[i];
            }
            return;
        }

        if(i >= urls.length -1){
            i = 0;
            return;
        }
        i += 1;
    }
</script>

<style>

    @keyframes bg {
        0% {
            background-color: black;
        }

        100% {
            background-color: #141414;
        }
    }

    .videoBG {
        position: absolute;
        width: 100vw;
        height: 100%;
        object-fit: cover;
        opacity: 1;
        animation-name: bg;
        animation-duration: 1s;
        animation-iteration-count: infinite;
        filter: brightness(0.5);
        background-color: black;
    }
</style>

<video class="videoBG  {noMobile ? 'd-none d-md-block' : ''}" on:ended={onEnd} bind:this={video} poster playsinline autoplay muted src="{urls[i]}"></video>